/**
 * Ryan O'Dowd
 * 2026-07-12
 * © Copyright 2026 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minWidth: 64,
    },
  };
};

export default getStyles;
